export const orange = '#663399';
export const pink = '#663399';
export const white = '#fff';
